(() => {
  const managerKey = '__mwStktGalleryV072';

  if (window[managerKey]) {
    window[managerKey].initializeGallery(document);
    return;
  }

  const initializeGallery = (root = document) => {
    const galleries = root.matches?.('[data-mw-stkt-gallery]')
      ? [root]
      : Array.from(root.querySelectorAll('[data-mw-stkt-gallery]'));

    galleries.forEach((gallery) => {
      if (gallery.dataset.galleryReady === 'true') return;

      const items = Array.from(gallery.querySelectorAll('[data-mw-stkt-gallery-item]'));
      const dialog = gallery.querySelector('[data-mw-stkt-gallery-dialog]');
      const image = gallery.querySelector('[data-mw-stkt-gallery-dialog-image]');
      const caption = gallery.querySelector('[data-mw-stkt-gallery-dialog-caption]');
      const closeButton = gallery.querySelector('[data-mw-stkt-gallery-close]');
      const previousButton = gallery.querySelector('[data-mw-stkt-gallery-previous]');
      const nextButton = gallery.querySelector('[data-mw-stkt-gallery-next]');
      const sliderTrack = gallery.querySelector('[data-mw-stkt-slider-track]');
      const sliderPrevious = gallery.querySelector('[data-mw-stkt-slider-previous]');
      const sliderNext = gallery.querySelector('[data-mw-stkt-slider-next]');
      const sliderDots = Array.from(gallery.querySelectorAll('[data-mw-stkt-slider-dot]'));

      if (!items.length || !dialog || !image || !caption || !closeButton || !previousButton || !nextButton) return;

      let currentIndex = 0;
      let sliderIndex = 0;
      let trigger = null;
      let previousBodyOverflow = '';
      let sliderFrame = null;
      const desktopZoomQuery = window.matchMedia('(min-width: 621px)');

      const renderImage = (index) => {
        currentIndex = (index + items.length) % items.length;
        const item = items[currentIndex];
        image.src = item.dataset.fullSrc || '';
        image.alt = item.dataset.alt || '';
        caption.textContent = item.dataset.caption || '';
      };

      const closeDialog = () => {
        if (dialog.open) dialog.close();
      };

      const updateZoomAvailability = () => {
        const zoomIsAvailable = desktopZoomQuery.matches;

        if (!zoomIsAvailable) closeDialog();
        items.forEach((item) => {
          item.disabled = !zoomIsAvailable;
        });
      };

      items.forEach((item, index) => {
        item.addEventListener('click', () => {
          if (!desktopZoomQuery.matches) return;

          trigger = item;
          renderImage(index);
          previousBodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          dialog.showModal();
        });
      });

      closeButton.addEventListener('click', closeDialog);
      previousButton.addEventListener('click', () => renderImage(currentIndex - 1));
      nextButton.addEventListener('click', () => renderImage(currentIndex + 1));

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') renderImage(currentIndex - 1);
        if (event.key === 'ArrowRight') renderImage(currentIndex + 1);
      });

      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousBodyOverflow;
        image.removeAttribute('src');
        if (trigger) trigger.focus();
      });

      if (sliderTrack && sliderPrevious && sliderNext && sliderDots.length) {
        const slides = items.map((item) => item.closest('.mw-stkt-gallery__entry'));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const updateSlider = (index) => {
          sliderIndex = (index + slides.length) % slides.length;
          sliderDots.forEach((dot, dotIndex) => {
            dot.setAttribute('aria-current', String(dotIndex === sliderIndex));
          });
        };

        const slideLeft = (slide) => (
          slide.getBoundingClientRect().left
          - sliderTrack.getBoundingClientRect().left
          + sliderTrack.scrollLeft
        );

        const goToSlide = (index) => {
          const nextIndex = (index + slides.length) % slides.length;
          sliderTrack.scrollTo({
            left: slideLeft(slides[nextIndex]),
            behavior: reducedMotion ? 'auto' : 'smooth',
          });
          updateSlider(nextIndex);
        };

        sliderPrevious.addEventListener('click', () => goToSlide(sliderIndex - 1));
        sliderNext.addEventListener('click', () => goToSlide(sliderIndex + 1));
        sliderDots.forEach((dot) => {
          dot.addEventListener('click', () => goToSlide(Number(dot.dataset.slideIndex || 0)));
        });

        sliderTrack.addEventListener('scroll', () => {
          if (sliderFrame) cancelAnimationFrame(sliderFrame);
          sliderFrame = requestAnimationFrame(() => {
            const nearestIndex = slides.reduce((nearest, slide, index) => {
              const currentDistance = Math.abs(slideLeft(slide) - sliderTrack.scrollLeft);
              const nearestDistance = Math.abs(slideLeft(slides[nearest]) - sliderTrack.scrollLeft);
              return currentDistance < nearestDistance ? index : nearest;
            }, 0);
            updateSlider(nearestIndex);
          });
        }, { passive: true });
      }

      desktopZoomQuery.addEventListener('change', updateZoomAvailability);
      updateZoomAvailability();

      gallery.mwStktGalleryCleanup = () => {
        desktopZoomQuery.removeEventListener('change', updateZoomAvailability);
        if (sliderFrame) cancelAnimationFrame(sliderFrame);
        closeDialog();
      };

      gallery.dataset.galleryReady = 'true';
    });
  };

  const destroyGallery = (root = document) => {
    const galleries = root.matches?.('[data-mw-stkt-gallery]')
      ? [root]
      : Array.from(root.querySelectorAll('[data-mw-stkt-gallery]'));

    galleries.forEach((gallery) => {
      gallery.mwStktGalleryCleanup?.();
      delete gallery.mwStktGalleryCleanup;
      delete gallery.dataset.galleryReady;
    });
  };

  window[managerKey] = { initializeGallery, destroyGallery };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeGallery());
  } else {
    initializeGallery();
  }

  document.addEventListener('shopify:section:load', (event) => initializeGallery(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyGallery(event.target));
})();
